import React from 'react';
import { Link } from 'react-router-dom';

import Img from './img';

const Logo = ({ background }) => {
    const defaultLogo = 'child-poverty-logo-orange.png';
    const logoColourMap = {
        'bg-pink': 'child-poverty-logo-2020-white.png',
        'bg-grey-20': 'child-poverty-logo-2020-blue.png',
        'bg-white': 'child-poverty-logo-2020-blue.png',
    };
    const image = background in logoColourMap ? logoColourMap[background] : defaultLogo;
    return (
        <Link to='/'>
            <Img filename={ image } className='w-32' />
        </Link>
    );
};

export default Logo;
